import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _GameNameVerticalBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 游戏名称垂直布局的内边距 */
  ['--game-name-vertical-padding']?: string;
  /** 上方名称的字号 */
  ['--top-name-font-size']?: string;
  /** 下方(品牌)名称字号 */
  ['--bottom-name-font-size']?: string;
  /** 下方距离上方名称的上外边距 */
  ['--bottom-name-margin-top']?: string
}
